import { Config } from "./interface";
import { getRuntimeValue } from "./runtime";

const config: Config = (() => {
  const config = {
    APP_BE_BASE_URL:
      getRuntimeValue("APP_BE_BASE_URL") ||
      process.env.APP_BE_BASE_URL ||
      "https://dev.munshify.com/",
    STRIPE_PUBLISHABLE_KEY:
      getRuntimeValue("STRIPE_PUBLISHABLE_KEY") ||
      process.env.STRIPE_PUBLISHABLE_KEY ||
      "pk_test_dev",
    GOOGLE_GEOCODE_API_KEY:
      getRuntimeValue("GOOGLE_GEOCODE_API_KEY") ||
      process.env.GOOGLE_GEOCODE_API_KEY ||
      "AIzaSyA7jJR9IkQZ8g686wRF23Unu1HGpfP",
    GOOGLE_LOGIN_CLIENT_ID:
      getRuntimeValue("GOOGLE_LOGIN_CLIENT_ID") ||
      process.env.GOOGLE_LOGIN_CLIENT_ID ||
      "475526477226-ikn58795npb8i6tdsni5lvq5v2dte2ug.apps.googleusercontent.com",
    GOOGLE_TAG_MANAGER_ID:
      getRuntimeValue("GOOGLE_TAG_MANAGER_ID") ||
      process.env.GOOGLE_TAG_MANAGER_ID ||
      "GTM-N8M7S8N",
    ALLOWED_BASE_URLS:
      getRuntimeValue("ALLOWED_BASE_URLS") ||
      process.env.ALLOWED_BASE_URLS ||
      (".munshify.com" as string),
    KEYCLOAK_URL:
      getRuntimeValue("KEYCLOAK_URL") ||
      process.env.KEYCLOAK_URL ||
      "https://dev-login.munshify.com",
    KEYCLOAK_REALM:
      getRuntimeValue("KEYCLOAK_REALM") ||
      process.env.KEYCLOAK_REALM ||
      "munshify",
    KEYCLOAK_CLIENT_ID:
      getRuntimeValue("KEYCLOAK_CLIENT_ID") ||
      process.env.KEYCLOAK_CLIENT_ID ||
      "frontend",
    ENVIRONMENT:
      getRuntimeValue("ENVIRONMENT") || process.env.ENVIRONMENT || "DEV",
    PROFILE: getRuntimeValue("PROFILE") || process.env.PROFILE || "DEV",
  };
  window.config = config;
  console.log("window config", window.config);
  return config;
})();
declare global {
  interface Window {
    config: Config;
  }
}
export const getConfig = (): Config => {
  return config;
};

export default config;
export { config };
export type { Config } from "./interface";
